import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import UserStore from './user/user.store';
import nutrients from './nutrients/nutrients.store';
import crop from './crop/crop.store';
import farms from './farms.store';
import countries from './countries.store';
import program from './program/program.store';
import misc from './misc.store';
import satellite from './satellite.store';
import textures from './textures.store';
import labs from './labs.store';
import market from './market.store';
import tests from './tests/tests.store';
import dashboard from './dashboard.store';
import ModalsStore from './modals/modals.store';
import TutorialsStore from './tutorials.store';
import fertilizers from './fertilizers/fertilizers.store';
import UserCropsStore from './user-crops.store';
import SidebarStore from './sidebar.store';
import UserSettingsStore from './user-settings.store';
import Appvars from './appvars.store';
import subAccount from './subAccount.store';
import unit from './unit/unit.store';
import TicketsStore from "./tickets/tickets.store"
import drainage from "./drainage/drainage.store"
import pdf from "./pdf.store"
import { NotesStore } from "./notes.store"

const store = new Vuex.Store({
  modules: {
    'tickets': TicketsStore,
    'user': UserStore,
    nutrients,
    crop,
    'modals': ModalsStore,
    farms,
    satellite,
    countries,
    program,
    misc,
    tests,
    labs,
    fertilizers,
    textures,
    subAccount,
    dashboard,
    drainage,
    market,
    pdf,
    'user-crops': UserCropsStore,
    'user-settings': UserSettingsStore,
    'tutorials': TutorialsStore,
    'sidebar': SidebarStore,
    'appvars': Appvars,
    'notes': NotesStore,
    unit: unit,
  },
  state: {

  },
  mutations: {

  },
  actions: {

  }
});

export default store;
